import { createReducer } from "@reduxjs/toolkit"

import { setCurrentUser, setPvOption } from "./actions"

interface AuthState {
  currentUser: any
  pvOption: boolean
}

const reducer = createReducer(
  {
    currentUser: null,
  } as AuthState,
  {
    [setCurrentUser.type]: (state, action: any) => {
      state.currentUser = action.payload
    },
    [setPvOption.type]: (state, action) => {
      state.pvOption = action.payload
    },
  },
)

export default reducer
